import { render } from "./poster.vue?vue&type=template&id=0abd2d04&scoped=true"
import script from "./poster.vue?vue&type=script&lang=js"
export * from "./poster.vue?vue&type=script&lang=js"

import "./poster.vue?vue&type=style&index=0&id=0abd2d04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abd2d04"]])

export default __exports__